<div>
  <h6 class="odx-title-6" i18n="@@global.procedureRooms">Procedure rooms</h6>

  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      class="procedure-room"
      (click)="addProcedureRoom()"
      [odxTooltip]="tooltipText"
      [odxTooltipOptions]="{ position: 'bottom-start' }"
      draggable="true"
      (dragstart)="dragProcedureRoom()"
    >
      <odx-icon name="plus" size="medium"></odx-icon>
    </button>
    <app-toggle-visibility-button
      [visible]="floorplanState.procedureRoomsVisible"
      (toggleEvent)="floorplanState.procedureRoomsVisible = $event"
    >
    </app-toggle-visibility-button>

    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.procedureRoomsItemTextVisible"
      (toggleEvent)="updateProcedureRoomsItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.procedureRoomsLocked"
      (toggleEvent)="floorplanState.procedureRoomsLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
